import _ from 'lodash'

import { Entity } from 'shared-libs/models/entity'

const PRINTABLE_TYPE_ENTITY_ID = '5209a80d-d216-4a27-acd3-56da546141a5'

export function isPrintable(entity: Entity) {
  return _.find(entity.activeMixins, (mixin: any) => {
    return mixin.entityId === PRINTABLE_TYPE_ENTITY_ID
  })
}
